import { deleteAuto } from './deleteAuto'
import { deleteStock } from './deleteStock'
import { getAuto, getAutoVistaVendedor, getAutoFull, getCarByCatalogidAndCarlotid, getCatalogId } from './getAuto'
import { getPaginatedListCatalogs } from './getPaginatedListCatalogs'
import { getPaginatedListVistaVendedor } from './getPaginatedListVistaVendedor'
import { getSaleTypes} from './getSaleTypes';
import { getSimilars, getSimilarsVistaVendedor, getSimilarsComparador } from './getSimilars'
import { postAuto } from './addAuto'
import { getStock } from './getStock'
import { getMassiveUploadSchema } from './getMassiveUploadSchema'
import { uploadCargaMasiva } from './uploadCargaMasiva'
import { getCounters } from './getCounters'
import { getPriceUpdateReport } from './getPriceUpdateReport'
import { getCarByLicensePlate } from './getCarByLicensePlate'
import { getCarByLicensePlateAndCompany } from './getCarByLicensePlateAndCompany'
import { postFileToUpdatePrices } from './postFileToUpdatePrices'
import { postFileToUpdatePublishPrices } from './postFileToUpdatePublishPrices'
import { addFileWhenCreate } from './addFileWhenCreate'
import { getLabels } from './getLabels'
import { syncSalesChannel } from './syncSalesChannel'
import { sendCatalogMail } from './sendCatalogMail'
import { getPublicCatalogLink } from './getPublicCatalogLink'
import { getPublicCatalog } from './getPublicCatalog'
import { getPublicCatalogToken } from './getPublicCatalogToken'
import { getProductHistoryList } from './getProductHistoryList'
import { getStocksListByCarId } from './getStocksListByCarId'
import { getCarsByDatamaster } from './getCarsByDatamaster'
import { checkIfTakingCarCouldBeDeleted } from './checkIfTakingCarCouldBeDeleted'
import { getGenerateBonificationsPriceExcel } from './getGenerateBonificationsPriceExcel'
import { postBonificationsMassImport, getBonificationsImportErrorMessage } from './postBonificationsMassImport'

export const Catalogs = {
  deleteAuto,
  deleteStock,
  getAuto,
  getAutoVistaVendedor,
  getAutoFull,
  getPaginatedListCatalogs,
  getPaginatedListVistaVendedor,
  getSaleTypes,
  getSimilars,
  getMassiveUploadSchema,
  getSimilarsVistaVendedor,
  getSimilarsComparador,
  postAuto,
  getStock,
  uploadCargaMasiva,
  getCounters,
  getPriceUpdateReport,
  getCarByLicensePlate,
  getCarByLicensePlateAndCompany,
  postFileToUpdatePrices,
  postFileToUpdatePublishPrices,
  addFileWhenCreate,
  getCarByCatalogidAndCarlotid,
  getCatalogId,
  getLabels,
  syncSalesChannel,
  sendCatalogMail,
  getPublicCatalog,
  getPublicCatalogLink,
  getPublicCatalogToken,
  getProductHistoryList,
  getStocksListByCarId,
  checkIfTakingCarCouldBeDeleted,
  getCarsByDatamaster,
  getGenerateBonificationsPriceExcel,
  postBonificationsMassImport,
  getBonificationsImportErrorMessage,
}
